import { expectRecord } from "./schema";
import { parseSafePaymentCard } from "./tenant-application-payment-setup";
export const STUDENT_BILLING_PAYMENT_SETUP_STATUSES = [
    "notStarted",
    "creating",
    "checkoutCreated",
    "processing",
    "ready",
    "failed",
    "expired"
];
export function parseStudentBillingPaymentSetupRequest(value) {
    const record = expectRecord(value, "studentBillingPaymentSetupRequest");
    if (Object.keys(record).length > 0) {
        throw new Error("studentBillingPaymentSetupRequest contains unknown fields");
    }
    return {};
}
export function parseStudentBillingPaymentMethodStateDto(value) {
    const record = expectRecord(value, "studentBillingPaymentMethodState");
    const allowed = ["payerId", "accountReady", "paymentMethodReady", "setupStatus", "activeAttemptId", "checkoutAvailable", "expiresAt", "card", "canRetry", "updatedAt"];
    if (Object.keys(record).some((key) => !allowed.includes(key)))
        throw new Error("studentBillingPaymentMethodState contains unknown fields");
    if (typeof record.payerId !== "string" || !record.payerId)
        throw new Error("payerId is required");
    if (typeof record.accountReady !== "boolean" || typeof record.paymentMethodReady !== "boolean" || typeof record.checkoutAvailable !== "boolean" || typeof record.canRetry !== "boolean") {
        throw new Error("invalid Student Billing payment state flags");
    }
    if (!STUDENT_BILLING_PAYMENT_SETUP_STATUSES.includes(record.setupStatus))
        throw new Error("invalid Student Billing setup status");
    const nullableString = (item) => item === null || typeof item === "string";
    if (!nullableString(record.activeAttemptId) || !nullableString(record.expiresAt) || !nullableString(record.updatedAt))
        throw new Error("invalid Student Billing payment state timestamp");
    const card = record.card === null ? null : parseSafePaymentCard(record.card);
    return { ...record, card };
}
export function parseStudentBillingPaymentSetupSessionDto(value) {
    const record = expectRecord(value, "studentBillingPaymentSetupSession");
    const allowed = ["attemptId", "checkoutUrl", "expiresAt", "status", "replayed"];
    if (Object.keys(record).some((key) => !allowed.includes(key)))
        throw new Error("studentBillingPaymentSetupSession contains unknown fields");
    if (typeof record.attemptId !== "string" || typeof record.checkoutUrl !== "string" || typeof record.expiresAt !== "string" || record.status !== "checkoutCreated" || typeof record.replayed !== "boolean") {
        throw new Error("invalid Student Billing payment setup session");
    }
    return record;
}
